import Vue from 'vue'
import index from '@/components/index.vue'

Vue.config.productionTip = false
import '@/assets/js/wx_share.js'
;(function(){
  var rem = document.createElement('script');
  rem.src = './rem.js';
  document.body.appendChild(rem)
})()
new Vue({
  render: h => h(index),
}).$mount('#app')
